export default __webpack_public_path__ + "static/data-vis-custom-chart-colors-light-1bff2f6543dda01af29bada68782757a2bce39beba28e29854d5c67a2a7a9bcb.png";